import { render, staticRenderFns } from "./pageIndex.vue?vue&type=template&id=25404e38&"
import script from "./pageIndex.vue?vue&type=script&lang=js&"
export * from "./pageIndex.vue?vue&type=script&lang=js&"
import style0 from "./pageIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports